var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./breadcrumb.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6c2d19b3\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./breadcrumb.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/breadCrumb/breadcrumb.vue
// module id = 3365
// module chunks = 1